// dc_info/DcInfoGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * DC_INFO Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-08-26 14:04:45 using DbdbTap
 ************************************************ */

export const DC_INFO_LIST_PART = gql`
fragment DcInfoListPart on DcInfo {
    dcCd
    dcTypeCd
    dcTypeName
    dcName
    useYn
    zipCd
    addr
    docknoStart
    docknoEnd
    officeTelno
    officeStaffName
    secuTelno
    secuStaffName
    transStaffName
    operStaffName
    pierTimeIntervalCd
    pierTimeInterval
    showOrder
    tempFore
    tempMid
    tempRear
    useTransType
    fontColor
    backColor
    regDate
    regUser
    regUserName
}
`;
/*
    lat
    lon
    xCoord
    yCoord
    zoneShape
    useZone
*/


export const LIST_DC_INFO = gql`
${DC_INFO_LIST_PART}
query ListDcInfo {
    dcInfoList {
        ...DcInfoListPart
    }
}
`;

export const GET_DC_INFO = gql`
${DC_INFO_LIST_PART}
query GetDcInfo($dcCd:String!) {
    dcInfoItem(dcCd:$dcCd) {
        ...DcInfoListPart
    }
}
`;

export const ADD_DC_INFO = gql`
${DC_INFO_LIST_PART}
mutation AddDcInfo($dcInfo:InputDcInfoAdd!) {
	dcInfoAdd(dcInfo: $dcInfo) {
		ok
		message
		list {
			...DcInfoListPart
		}
	}
}
`;

export const EDIT_DC_INFO = gql`
${DC_INFO_LIST_PART}
mutation EditDcInfo($dcInfo:InputDcInfoEdit!) {
	dcInfoEdit(dcInfo: $dcInfo) {
		ok
		message
		list {
			...DcInfoListPart
		}
	}
}
`;

export const REMOVE_DC_INFO = gql`
${DC_INFO_LIST_PART}
mutation RemoveDcInfo($dcInfo:InputDcInfoRemove!) {
	dcInfoRemove(dcInfo: $dcInfo) {
		ok
		message
		list {
			...DcInfoListPart
		}
	}
}
`;

// dcInfoSetZone(dcInfo: InputDcInfoSetZone!): CommonResponse
export const SET_ZONE_DC_INFO = gql`
mutation SetZoneDcInfo($dcInfo:InputDcInfoSetZone!) {
    dcInfoSetZone(dcInfo: $dcInfo) {
        ok
        message
    }
}
`;

// dcInfoSetUsage(dcInfo: InputDcInfoSetUseYn!): ResponseWithDcInfoList
export const SET_USAGE_DC_INFO = gql`
${DC_INFO_LIST_PART}
mutation SetUsageDcInfo($dcInfo:InputDcInfoSetUseYn!) {
    dcInfoSetUsage(dcInfo: $dcInfo) {
        ok
        message
        list {
            ...DcInfoListPart
        }
    }
}
`;

/*
    dcInfoListWithRentVehCount: [DcInfo]!

        SELECT
            d.dc_cd AS dcCd,
            d.dc_type_cd AS dcTypeCd,
            d.dc_type_name AS dcTypeName,
            d.dc_name AS dcName,
            x.cnt AS countVehicle
        FROM dc_info d, (
        	SELECT c.dc_cd, sum(cnt) AS cnt
			FROM com_info c, (
	        	SELECT v.com_id, count(*) AS cnt FROM veh_info v
		       	WHERE v.rent_yn='Y'
		       	GROUP BY v.com_id 
	        ) v
	        WHERE c.com_id=v.com_id
	        GROUP BY c.dc_cd
        ) x
        WHERE x.dc_cd=d.dc_cd
        ORDER BY d.dc_type_cd, d.dc_name
*/
export const LIST_DC_INFO_WITH_RENT_VEH_COUNT = gql`
query ListDcInfoWithRentVehCount {
    dcInfoListWithRentVehCount {
        dcCd
        dcTypeCd
        dcTypeName
        dcName
        countVehicle
    }
}
`;

// dcInfoListUnsafe: [DcInfoSimple]!
export const LIST_DC_INFO_UNSAFE = gql`
query ListDcInfoUnsafe {
    dcInfoListUnsafe {
        dcCd
        dcName
    }
}
`;
